import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from './hooks/useAuth';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import OnboardPage from './pages/OnboardPage';
import AppLayout from './components/AppLayout';
import DashboardPage from './pages/DashboardPage';
import DomainsPage from './pages/DomainsPage';
import DomainDetailPage from './pages/DomainDetailPage';
import DnsStatusPage from './pages/DnsStatusPage';
import AuditPage from './pages/AuditPage';
import SettingsPage from './pages/SettingsPage';
import BillingPage from './pages/BillingPage';
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminTenants from './pages/admin/AdminTenants';
import AdminUsers from './pages/admin/AdminUsers';
import AdminConfig from './pages/admin/AdminConfig';
import AdminAudit from './pages/admin/AdminAudit';

// -- Super-admin route guard ------------------------------------------------

function SuperAdminRoute() {
  // In a real implementation this would verify the secret param against the
  // server and check that the user has the super_admin role. For now it simply
  // renders the child routes.
  return <Outlet />;
}

// ---------------------------------------------------------------------------
// Root component
// ---------------------------------------------------------------------------

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />

          {/* Protected: onboarding */}
          <Route element={<ProtectedRoute />}>
            <Route path="/onboard" element={<OnboardPage />} />
          </Route>

          {/* Protected: main application */}
          <Route element={<ProtectedRoute />}>
            <Route path="/app" element={<AppLayout />}>
              <Route index element={<DashboardPage />} />
              <Route path="domains" element={<DomainsPage />} />
              <Route path="domains/:id" element={<DomainDetailPage />} />
              <Route path="dns" element={<DnsStatusPage />} />
              <Route path="audit" element={<AuditPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="settings/billing" element={<BillingPage />} />
            </Route>
          </Route>

          {/* Protected + super admin: admin panel */}
          <Route element={<ProtectedRoute />}>
            <Route path="/__admin/:secret" element={<SuperAdminRoute />}>
              <Route element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="tenants" element={<AdminTenants />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="config" element={<AdminConfig />} />
                <Route path="audit" element={<AdminAudit />} />
              </Route>
            </Route>
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
